import { useMutationWithResultNotification } from 'api/mutations/useMutationWithResultNotification';
import { deleteOrganizationSymptoms } from 'api/symptoms';
import {
  displayErrorArrayNotifications,
  displaySuccessNotification,
} from 'modules/Notifications';

function useRemoveSymptomInOrganization(
  organizationId: string,
  successFb?: () => void
) {
  return useMutationWithResultNotification({
    asyncApiFunction: async (observationMeaningId: string) => {
      await deleteOrganizationSymptoms(organizationId, observationMeaningId);
    },
    resetOnResult: true,
    onSuccess: () => {
      displaySuccessNotification(
        'Api.Mutations.Symptoms.RemoveSymptomInOrganization.success'
      );
      if (successFb) successFb();
    },
    onErrorArray: (errors) => {
      displayErrorArrayNotifications(
        errors,
        'Api.Mutations.Symptoms.RemoveSymptomInOrganization.failure'
      );
    },
  });
}

export default useRemoveSymptomInOrganization;
